export default {
  academic: "candidate/profile/qualification",
  remove: "candidate/profile/qualification/delete",
  specializations: "setup/specializations",
  qualificationCodes: "setup/qualificationCodes",
  professionalCodes: "setup/professionalCodes",
  skills: "candidate/profile/skill",
  academicCodes: "setup/academicCodes",
  SINGLE: (id) => `candidate/profile/qualification/${id}`,
};
